import { createApi } from "@reduxjs/toolkit/query/react";
import {
  GET_HOME_PAGE_BANNER,
  GET_HOME_PAGE_CATEGORY,
  GET_HOME_PAGE_TOP_BRAND,
  GET_HOME_SECTIONS,
  GET_HOME_SHOP_HEALTH_CONDITION,
  GET_POPULAR_PRODUCT,
} from "../routes";
import baseQuery from "../baseQuery";
export const homeApi = createApi({
  reducerPath: "homeApi",
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    homePageCategory: builder.query({
      query: () => GET_HOME_PAGE_CATEGORY,
      transformResponse: (response: ApiResponse<MedicineCategory[]>) => {
        return response?.data;
      },
    }),
    homePageTopBrand: builder.query({
      query: () => GET_HOME_PAGE_TOP_BRAND,
      transformResponse: (response: ApiResponse<Brand[]>) => {
        return response?.data;
      },
    }),
    homePageShopByHealthConditions: builder.query({
      query: () => GET_HOME_SHOP_HEALTH_CONDITION,
      transformResponse: (
        response: ApiResponse<HealthConditionDataTypes[]>
      ) => {
        return response?.data;
      },
    }),
    getPopularProduct: builder.query({
      query: () => GET_POPULAR_PRODUCT,
      transformResponse: (
        response: ApiResponse<MedicineTypes[]>
      ) => {
        return response?.data;
      },
    }),
    getHomeBanner: builder.query({
      query: () => GET_HOME_PAGE_BANNER,
      transformResponse: (
        response: ApiResponse<BannerTypes[]>
      ) => {
        return response?.data;
      },
    }),
    getHomeSections: builder.query({
      query: (page: number) => ({
        url: GET_HOME_SECTIONS,
        params: { page },
      }),
      transformResponse: (
        response: ApiResponse<HomeSectionsDataTypes[]>
      ) => {
        return response?.data;
      },
    }),
  }),
});

export const {
  useHomePageCategoryQuery,
  useHomePageTopBrandQuery,
  useHomePageShopByHealthConditionsQuery,
  useGetHomeSectionsQuery,
  useGetPopularProductQuery,
  useGetHomeBannerQuery
} = homeApi;
